import * as React from 'react';
import { useNavigate } from 'react-router-dom';

import { Button } from '@independent-software/typeui/controls/Button';
import { Icon } from '@independent-software/typeui/controls/Icon';

import { AuthContext } from '../../AuthContext';
import { Container, Content, BottomBar } from '../../modules';
import { User } from '../../resource/';
import { ListUsers } from './ListUsers';
import { Gate } from '../../controls/Gate';

const UserList = () => {
  const auth = React.useContext(AuthContext);
  const navigate = useNavigate();

  // Go to add user view.
  const handleAdd = () => {
    navigate('/users/add');
  }  

  // Go to view user view.
  const handleClick = (item: User) => {
    navigate(`/users/${item.id}`);
  }  

  return (
    <Container>
      <Content>
        <ListUsers auth={auth} name="users" onClick={handleClick}/>
      </Content>
      <BottomBar>
        <Gate right='can_edit_users'>
          <Button primary onClick={handleAdd}><Icon name="plus"/> Add user</Button>
        </Gate>
      </BottomBar>
    </Container>
  );
}

export { UserList }
